// ============================================================
//  src/components/layout/BottomNav.js
//  Fixed bottom navigation — matches PHP bn-item pattern
// ============================================================
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './BottomNav.css';

export default function BottomNav() {
  const { user } = useAuth();
  const isEarner = user?.isEarner;

  const items = [
    { to: '/dashboard',    icon: 'fas fa-home',       label: 'Home'    },
    { to: '/my-orders',    icon: 'fas fa-list-check',  label: 'Orders'  },
    isEarner
      ? { to: '/earner/tasks', icon: 'fas fa-tasks', label: 'Earn' }
      : { to: '/tasks',        icon: 'fas fa-tasks', label: 'Tasks' },
    { to: '/fund-wallet',  icon: 'fas fa-plus-circle', label: 'Fund'    },
    { to: '/profile',      icon: 'fas fa-user',        label: 'Profile' },
  ];

  return (
    <nav className="bottom-nav">
      {items.map(({ to, icon, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `bn-item${isActive ? ' active' : ''}`}
        >
          <i className={icon}></i>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
